let three_section = jQuery('.cards__section').not('.homepage__news')

three_section.each( function() {

    var carouselStatus = jQuery('.carousel-status', this)

    const cardsSlider = jQuery('.carousel__cards__three', this),
        cardsSlide = jQuery('.carousel__card', this)

    if (cardsSlider.length > 0 && cardsSlide.length > 1) {

        var carousel = cardsSlider.flickity({
            cellSelector: '.carousel__card',
            prevNextButtons: false,
            autoPlay: true,
            // pauseAutoPlayOnHover: false,
            wrapAround: true,
            pageDots: false,
            groupCells: false,
            // contain: true,
            cellAlign: 'center',
            // lazyLoad: 2,
            draggable: true,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 45,
                x3: 20
            }
        })

        jQuery(".carousel__card").addClass("pageloaded");

        // Update status on Flickity event
        carousel.on('select.flickity', () => {
            updateStatus(this, carousel);
        });

        updateStatus(this, carousel);   
        setupCarouselNavigation(this, carousel);

    }
})

let four_section = jQuery('.cards__section')

four_section.each( function() {

    var carouselStatus = jQuery('.carousel-status', this)

    const cardsSliderFour = jQuery('.carousel__cards__four', this),
        cardsSlideFour = jQuery('.carousel__card', this)

    if (cardsSliderFour.length > 0 && cardsSlideFour.length > 1) {

        var carousel = cardsSliderFour.flickity({
            cellSelector: '.carousel__card',
            prevNextButtons: false,
            autoPlay: false,
            // pauseAutoPlayOnHover: false,
            // wrapAround: true,
            pageDots: false,
            groupCells: true,
            // contain: true,
            cellAlign: 'left',
            // lazyLoad: 2,
            draggable: true,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 45,
                x3: 20
            }
        })

        jQuery(".carousel__card").addClass("pageloaded");
        updateStatus(this, carousel);
        setupCarouselNavigation(this, carousel);

        // Update status on Flickity event
        carousel.on('select.flickity', () => {
            updateStatus(this, carousel);
        });

    }
})

let explore_section = jQuery('.homepage__explore')

explore_section.each(function () {

    const exploreSlider = jQuery('.carousel__cards__explore', this),
        exploreSlide = jQuery('.carousel__card', this)

    if (exploreSlider.length === 0) {
        return
    }

    jQuery('.carousel__card', this).addClass('pageloaded')

    if (exploreSlide.length <= 1) {
        jQuery('.homepage__explore__nav', this).hide()
        return
    }

    var carousel = exploreSlider.flickity({
        cellSelector: '.carousel__card',
        prevNextButtons: false,
        autoPlay: false,
        pageDots: false,
        groupCells: true,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        wrapAround: false
    })

    var flkty = carousel.data('flickity')

    if (flkty.slides.length <= 1) {
        jQuery('.homepage__explore__nav', this).hide()
        return
    }

    updateStatus(this, carousel)
    setupCarouselNavigation(this, carousel)
    updateAssetProgress(this, carousel)

    carousel.on('select.flickity', () => {
        updateStatus(this, carousel)
        updateAssetProgress(this, carousel)
        updateButtonStatus(this, carousel)
    })
})

let asset_summary_section = jQuery('.asset__summary')

asset_summary_section.each(function () {

    const assetSlider = jQuery('.carousel__cards__asset', this),
        assetSlide = jQuery('.carousel__card', this)

    if (assetSlider.length === 0) {
        return
    }

    jQuery('.carousel__card', this).addClass('pageloaded')

    if (assetSlide.length <= 1) {
        jQuery('.asset__summary__nav', this).hide()
        return
    }

    var carousel = assetSlider.flickity({
        cellSelector: '.carousel__card',
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        wrapAround: false
    })

    var flkty = carousel.data('flickity')

    if (flkty.slides.length <= 1) {
        jQuery('.asset__summary__nav', this).hide()
        return
    }

    updateStatus(this, carousel)
    setupCarouselNavigation(this, carousel)
    updateAssetProgress(this, carousel)

    carousel.on('select.flickity', () => {
        updateStatus(this, carousel)
        updateAssetProgress(this, carousel)
        updateButtonStatus(this, carousel)
    })

    // Keyboard tabbing into an off-screen cell makes the browser scroll the
    // overflow:hidden viewport, which desyncs Flickity. Move to that cell's
    // group instead and undo the native scroll.
    const viewport = jQuery('.flickity-viewport', assetSlider)

    assetSlider.on('focusin', '.carousel__card', function () {
        // Move instantly so the focused cell is in its final position, then undo
        // the browser's native scroll of the overflow:hidden viewport.
        carousel.flickity('selectCell', this, false, true)
        viewport.scrollLeft(0)

        // The cell just shifted via transform, so any tooltip that opened on
        // focus is now mispositioned. Nudge jBox to reposition open tooltips.
        window.requestAnimationFrame(function () {
            viewport.scrollLeft(0)
            jQuery(window).trigger('resize')
        })
    })

    viewport.on('scroll', function () {
        if (viewport.scrollLeft() !== 0) {
            viewport.scrollLeft(0)
        }
    })
})

function updateAssetProgress(container, carousel) {
    const thumb = jQuery('.carousel-progress__thumb', container)
    if (!thumb.length) {
        return
    }

    const flkty = carousel.data('flickity')
    const totalGroups = flkty.slides.length

    if (totalGroups <= 1) {
        thumb.css({ width: '100%' })
        return
    }

    const progress = (flkty.selectedIndex + 1) / totalGroups

    thumb.css({ width: (progress * 100) + '%' })
}

function updateStatus(container, carousel) {
    var carouselStatus = jQuery('.carousel-status', container);

    var slideNumber = carousel.data('flickity').selectedIndex + 1;
    var slideLength = carousel.data('flickity').slides.length;
    
    carouselStatus.html('<div class="slide-number">' + slideNumber + '</div> / <div class="slide-length">' + slideLength + '</div>');
    
    // Hide navigation buttons if there's only one slide
    var prevNextButtons = jQuery('.prev-next-buttons', container);
    if (slideNumber === 1 && slideLength === 1) {
        prevNextButtons.hide();
    } else {
        prevNextButtons.show();
    }
}

function announceNewsGroup(container, carousel) {
    const status = jQuery('.carousel-status', container)
    const flkty = carousel.data('flickity')

    if (!status.length || !flkty) {
        return
    }

    status.text('Showing group ' + (flkty.selectedIndex + 1) + ' of ' + flkty.slides.length)
}

function setCarouselButtonState(button, isDisabled) {
    button.toggleClass('disabled', isDisabled);
    button.prop('disabled', isDisabled);
    button.attr('aria-disabled', isDisabled ? 'true' : 'false');
}

function updateButtonStatus(container, carousel) {
    const prevButton = jQuery('.button--previous', container);
    const nextButton = jQuery('.button--next', container);
    const flkty = carousel.data('flickity');

    if (!flkty) {
        return;
    }

    const currentIndex = flkty.selectedIndex;
    const totalSlides = flkty.slides.length;

    setCarouselButtonState(prevButton, currentIndex === 0);
    setCarouselButtonState(nextButton, currentIndex === totalSlides - 1);
}

function setupCarouselNavigation(container, carousel) {
    // previous
    const prevButton = jQuery('.button--previous', container);
    prevButton.on('click', function() {
        carousel.flickity('previous');
        updateStatus(container, carousel); // Pass the correct container here
        updateButtonStatus(container, carousel);
    });

    prevButton.on('keypress', function(e) {
        if (e.which == 13) {
            carousel.flickity('previous');
            updateStatus(container, carousel); // Pass the correct container here
            updateButtonStatus(container, carousel);
        }
    });

    // next
    const nextButton = jQuery('.button--next', container);
    nextButton.on('click', function() {
        carousel.flickity('next');
        updateStatus(container, carousel); // Pass the correct container here
        updateButtonStatus(container, carousel);
    });

    nextButton.on('keypress', function(e) {
        if (e.which == 13) {
            carousel.flickity('next');
            updateStatus(container, carousel); // Pass the correct container here
            updateButtonStatus(container, carousel);
        }
    });

    updateButtonStatus(container, carousel);
}

function forceNewsCarouselResize(carousel) {
    const flkty = carousel.data('flickity')

    if (!flkty || !flkty.isActive || flkty.isDragging) {
        return false
    }

    // Flickity no-ops resize() while a select animation is running, so
    // 1/2/3-column grouping would stick at the previous breakpoint.
    flkty.isAnimating = false
    carousel.flickity('resize')

    if (typeof flkty.updateDraggable === 'function') {
        flkty.updateDraggable()
    }

    return true
}

function bindNewsCarouselResize(carousel) {
    const element = carousel.get(0)
    const track = element && element.parentElement ? element.parentElement : element

    if (!track) {
        return
    }

    let lastWidth = track.clientWidth
    let queued = false
    let ticking = false

    function apply() {
        if (!forceNewsCarouselResize(carousel)) {
            queued = true
            return
        }

        queued = false
        lastWidth = track.clientWidth
    }

    function schedule() {
        const width = track.clientWidth

        if (Math.abs(width - lastWidth) < 1) {
            return
        }

        queued = true
        apply()
    }

    function request() {
        if (ticking) {
            return
        }

        ticking = true
        window.requestAnimationFrame(function () {
            ticking = false
            schedule()
        })
    }

    carousel.on('settle.flickity', function () {
        if (queued) {
            apply()
        }
    })

    if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(request)
        observer.observe(track)
    }

    window.addEventListener('resize', request)

    ;['(min-width: 768px)', '(min-width: 1024px)'].forEach(function (query) {
        const media = window.matchMedia(query)
        const onChange = function () {
            lastWidth = -1
            queued = true
            apply()
        }

        if (typeof media.addEventListener === 'function') {
            media.addEventListener('change', onChange)
        } else if (typeof media.addListener === 'function') {
            media.addListener(onChange)
        }
    })
}

let news_section = jQuery('.homepage__news')

news_section.each(function () {
    const newsSlider = jQuery('.carousel__cards__three', this)
    const newsSlide = jQuery('.carousel__card', this)

    if (newsSlider.length === 0) {
        return
    }

    jQuery('.carousel__card', this).addClass('pageloaded')

    if (newsSlide.length <= 1) {
        jQuery('.homepage__news__nav', this).hide()
        return
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    var carousel = newsSlider.flickity({
        cellSelector: '.carousel__card',
        prevNextButtons: false,
        autoPlay: false,
        pageDots: false,
        groupCells: true,
        cellAlign: 'left',
        contain: true,
        draggable: !reduceMotion,
        wrapAround: false,
        selectedAttraction: reduceMotion ? 1 : 0.025,
        friction: reduceMotion ? 1 : 0.28
    })

    var flkty = carousel.data('flickity')

    if (!flkty || flkty.slides.length <= 1) {
        jQuery('.homepage__news__nav', this).hide()
        return
    }

    updateStatus(this, carousel)
    setupCarouselNavigation(this, carousel)
    updateAssetProgress(this, carousel)
    updateButtonStatus(this, carousel)
    announceNewsGroup(this, carousel)

    carousel.on('select.flickity', () => {
        updateStatus(this, carousel)
        updateAssetProgress(this, carousel)
        updateButtonStatus(this, carousel)
        announceNewsGroup(this, carousel)
    })

    carousel.on('resize.flickity', () => {
        const instance = carousel.data('flickity')

        if (!instance || instance.slides.length <= 1) {
            jQuery('.homepage__news__nav', this).hide()
        } else {
            jQuery('.homepage__news__nav', this).show()
        }

        updateAssetProgress(this, carousel)
        updateButtonStatus(this, carousel)
        updateStatus(this, carousel)
        announceNewsGroup(this, carousel)
    })

    bindNewsCarouselResize(carousel)

    const viewport = jQuery('.flickity-viewport', newsSlider)

    newsSlider.on('focusin', '.carousel__card', function () {
        carousel.flickity('selectCell', this, false, true)
        viewport.scrollLeft(0)
    })

    viewport.on('scroll', function () {
        if (viewport.scrollLeft() !== 0) {
            viewport.scrollLeft(0)
        }
    })
})

function announceHomepageAnnouncement(container, carousel) {
    const status = jQuery('.carousel-status', container)
    const flkty = carousel.data('flickity')

    if (!status.length || !flkty) {
        return
    }

    status.text('Announcement ' + (flkty.selectedIndex + 1) + ' of ' + flkty.slides.length)
}

jQuery('.homepage__announcements.has-nav').each(function () {
    const root = jQuery(this)
    const track = jQuery('.homepage__announcements__track', this)
    const slides = jQuery('.homepage__announcements__slide', this)

    if (track.length === 0 || slides.length <= 1) {
        jQuery('.homepage__announcements__nav', this).hide()
        return
    }

    root.addClass('is-ready')

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    const carousel = track.flickity({
        cellSelector: '.homepage__announcements__slide',
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        autoPlay: reduceMotion ? false : 5000,
        pauseAutoPlayOnHover: true,
        cellAlign: 'center',
        contain: false,
        adaptiveHeight: true,
        draggable: !reduceMotion,
        selectedAttraction: reduceMotion ? 1 : 0.025,
        friction: reduceMotion ? 1 : 0.28
    })

    const flkty = carousel.data('flickity')

    if (!flkty || flkty.slides.length <= 1) {
        jQuery('.homepage__announcements__nav', this).hide()
        return
    }

    carousel.flickity('resize')

    jQuery('.button--previous', this).on('click', function () {
        carousel.flickity('previous')
    })

    jQuery('.button--next', this).on('click', function () {
        carousel.flickity('next')
    })

    announceHomepageAnnouncement(this, carousel)

    carousel.on('select.flickity', function () {
        announceHomepageAnnouncement(root, carousel)
    })
})